export default __webpack_public_path__ + "static/media/voucher.adc073ba.png";